export default "__VITE_ASSET__hKcAtYTN__"